import QuickLaunchSide from "./side";
import AppGroup from "Pages/NewHome/AppGroup";
import "./index.less";

const QuickLaunch = AppGroup; // 快速发起一开始是用常用应用的架子处理的，不好迁移，先用AppGroup承载
export default QuickLaunch;

QuickLaunch.SidePanel = QuickLaunchSide;